import React from 'react';
import {reduxForm} from 'redux-form';
import {filterTypes} from 'infrastructure/js/enums/filterTypes';
import { createLabelHelper } from 'infrastructure/js/utils/labelHelper';
import {gridsNames} from '../../../../enums/gridsNames';
import LabelWithTooltipCell from '../../../Common/CustomGridCells/LabelWithTooltipCell/labelWithTooltipCell.js';
import Grid from 'infrastructure/js/components/Grid/gridWrapper';
import AssetAlertPopoverCell from '../../../Common/CustomGridCells/AssetAlertPopoverCell/assetAlertPopoverCell.js';
import {FetchEntitiesFilters} from '../../../../enums/fetchEntitiesFilters';
import {EntityPropertyTypes} from '../../../../enums/entityPropertyTypes';
import EntityIdCell from '../../../Common/CustomGridCells/EntityIdCell/entityIdCell'
import LastOperationCell from '../../../Common/CustomGridCells/LastOperationCell/lastOperationCell';
import {navigationStates} from '../../../../enums/navigationStates';
import {alertStatus, alertType, getAlertColumnFilterSections} from '../../../../utils/alertFilterSectionHelper';
import GridHelper from '../../../../../../infrastructure/js/components/Grid/Utils/gridHelper';
import LabelWithStyleCell from '../../../Common/CustomGridCells/LabelWithStyleCell/labelWithStyleCell';

import './archivedKitsGrid.scss';

class ArchivedKitsGrid extends React.PureComponent {

  filterConfig = [
      {fieldName: 'assetStatus', filterName: 'assetStatus', getOptions: true},
      {fieldName: 'kitType.businessId', filterName: 'kitType', getOptions: false},
      {fieldName: 'revision', filterName: 'kitTypeRevision', getOptions: true},
      {fieldName: 'businessId', filterName: 'businessId', getOptions: false},
      {fieldName: 'alertStatus', filterName: 'assetAlert'},
      {fieldName: 'lastStatusChangeDate.epochDateTime', filterName: 'lastStatusChangeDate'},
      {fieldName: 'partType.businessId', filterName: 'kitPart', getOptions: true},
      {fieldName: 'workOrder.businessId', filterName: 'kitWorkOrder', getOptions: true},
      {fieldName: 'project.businessId', filterName: 'kitProject', getOptions: true},
      {fieldName: 'lastOperation', filterName: 'assetLastOperationDate', getOptions: true},
  ];

  constructor (props) {
    super(props);
    this.labels = createLabelHelper('mat.grid.');

    this.columnsConfig = this.createColumnsConfig();
  }

  createColumnsConfig = () => {
    return [
      {
        fieldName: 'alertStatus',
        title: this.labels.get('columns.alert.title'),
        filterType: filterTypes.MULTI_SECTIONS,
        filterName: 'assetAlert',
        filterSections: getAlertColumnFilterSections([alertStatus.NO_ALERT, alertStatus.WARNING, alertStatus.ERROR],
          [alertType.ETL_BOND, alertType.ETL_CURE, alertType.EXPIRATION, alertType.DUE_DATE, alertType.MISPLACED, alertType.DEFROSTING]),
        width: 120,
        columnOptions: {
          cellComponent: AssetAlertPopoverCell,
          sort: 'desc',
          valueGetter: (params) => {
            return {
              description: '',
              alerts: params.data.alerts,
              alertStatus: params.data.alertStatus,
              exposureTimeLeftBond: params.data.exposureTimeLeftBond,
              exposureTimeLeftCure: params.data.exposureTimeLeftCure,
              expirationDaysLeft: params.data.m_ExpirationDaysLeft,
              expirationDate: params.data.expirationDate,
              defrostingTimeLeft: params.data.defrostingTimeLeft,
              dueDateLeft: params.data.dueDateLeft
            };
          }
        },
      },
      {
        fieldName: 'assetStatus',
        title: this.labels.get('columns.status.title'),
        filterType: filterTypes.MULTI_SELECT,
        filterName: 'assetStatus',
        valueFormatter: (params) => {
          return (params.data.assetStatusLabel || '');
        },
        columnOptions:{
          valueGetter: (params) => {
            return (params.data.assetStatus || '');
          },
        }
      },
      {
        fieldName: 'lastStatusChangeDate.epochDateTime',
        title: this.labels.get('columns.archivingDate.title'),
        filterType: filterTypes.NONE,
        valueFormatter: (params) => {
          return (params.data && params.data.m_archivingDate ? params.data.m_archivingDate : '');
        },
        columnOptions:{
          headerComponentParams: (GridHelper.getDateFormatHeaderIcon()),
          valueGetter: (params) => {
            return params.data.lastStatusChangeDate?.epochDateTime;
          },
        }
      },
      {
        fieldName: 'kitType.businessId',
        title: this.labels.get('columns.kitType.title'),
        filterType: filterTypes.MULTI_SELECT_ASYNC,
        filterName: 'kitType',
        fetchConfig: {
          entityType: EntityPropertyTypes.KIT_TYPE_BUSINESS_ID,
          filter: [FetchEntitiesFilters.ALL],
          action: this.props.actions.fetchEntities
        },
        columnOptions: {
          cellComponent: LabelWithTooltipCell,
          valueGetter: (params) => {
            return params.data.kitType?.businessId || '';
          }
        }
      },
      {
        fieldName: 'kitType.revision',
        title: this.labels.get('columns.kitTypeVersion.title'),
        filterType: filterTypes.MULTI_SELECT,
        filterName: 'kitTypeRevision',
        columnOptions: {
          cellComponent: LabelWithStyleCell,
          valueGetter: (params) => {
            return {
              label: params?.data?.kitType?.revision || '',
              style: params?.data?.kitType?.latestRevision ? null : { color: '#d9385c' },
            };
          },
        },
      },
      {
        fieldName: 'businessId',
        title: this.labels.get('columns.kitId.title'),
        filterType: filterTypes.MULTI_SELECT_ASYNC,
        filterName: 'businessId',
        fetchConfig: {
          entityType: EntityPropertyTypes.KIT_BUSINESS_ID,
          filter: [FetchEntitiesFilters.ARCHIVED],
          action: this.props.actions.fetchEntities
        },
        columnOptions: {
          cellComponent: EntityIdCell,
          valueGetter: (params) => {
            return {
                id: params.data.id,
                type: navigationStates.KIT,
                label:  params.data.businessId
              };
          }
        }
      },
      {
        fieldName: 'partType.businessId',
        title: this.labels.get('columns.partType.title'),
        filterType: filterTypes.MULTI_SELECT,
        filterName: 'kitPart',
        columnOptions: {
          cellComponent: LabelWithTooltipCell,
        }
      },
      {
        fieldName: 'workOrder.businessId',
        title: this.labels.get('columns.workOrder.title'),
        filterType: filterTypes.MULTI_SELECT,
        filterName: 'kitWorkOrder',
        columnOptions: {
          cellComponent: EntityIdCell,
          valueGetter: (params) => {
            if (params.data.workOrder) {
              return {
                id: params.data.workOrder.id,
                label: params.data.workOrder.businessId,
                type: navigationStates.WORKORDER
              };
            }
            return {};
          }
        }
      },
      {
        fieldName: 'project.businessId',
        title: this.labels.get('columns.project.title'),
        filterType: filterTypes.MULTI_SELECT,
        filterName: 'kitProject',
        columnOptions: {
          cellComponent: LabelWithTooltipCell,
        }
      },
      {
        fieldName: 'lastOperation',
        title: this.labels.get('columns.lastOperation.title'),
        filterType: filterTypes.NONE,
        width: 205,
        columnOptions: {
          cellComponent: LastOperationCell,
          headerComponentParams: { headerTextStyle: { marginLeft: '0px' } },
        },
      },
    ]
  }


  render() {
    return (
      <div className="archive-kits-grid">
        <Grid gridName={gridsNames.PREDEFINED_LIST_ARCHIVE_KITS}
              columnsConfig={this.columnsConfig}
              actions={this.props.actions}
              filterConfig={this.filterConfig}
              gridProps={
                {
                  filterPersistence: true,
                  getRowHeight: () => 84
                }
              }
        >
        </Grid>
      </div>
    );
  }
}

export default reduxForm({
    form: 'ArchiveKitsGrid'
  }
)(ArchivedKitsGrid);
